(function () {
  var loaded = false;

  function loadOpacityFix() {
    if (loaded || !window.__opacityFixAssetUrl) return;
    loaded = true;

    var script = document.createElement('script');
    script.src = window.__opacityFixAssetUrl;
    script.defer = true;
    document.head.appendChild(script);
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadOpacityFix, { timeout: 5000 });
    } else {
      setTimeout(loadOpacityFix, 4000);
    }
  }

  window.addEventListener('load', schedule, { once: true });
})();
